import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
/*  {
    path: '/',
    name: 'home',
    component: HomeView
  },*/
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { keepAlive: true } // 添加这行
    },
    // 添加支持动态share参数的路由
    {
        path: '/:share',
        name: 'IndexView',
        component: () => import('@/views/IndexView.vue'),
        props: true, // 允许将路由参数作为props传递给组件
        meta: { keepAlive: false }
    },
    /*{
        path: '/login',
        name: 'login',
        component: () => import('@/components/LoginView.vue'),
    },
    {
        path: '/editPwd',
        name: 'EditPwdView',
        component: () => import('@/components/EditPwdView.vue'),
    },
    {
        path: '/resetPassword',
        name: 'ResetPwdView',
        component: () => import('@/components/ResetPwdView.vue'),
    },
    {
        path: '/workorder-detail',
        name: 'WorkordDetail',
        component: () => import('@/components/WorkordDetail.vue')
    },
    {
        path: '/deptStaff',
        name: 'DeptStaffView',
        component: () => import('@/components/DeptStaffView.vue'),
        meta: { keepAlive: true } 
    },
    {
        path: '/workRecordView',
        name: 'WorkRecordView',
        component: () => import('@/components/WorkRecordView.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/workRecordJmsView',
        name: 'WorkRecordJmsView',
        component: () => import('@/components/WorkRecordJmsView.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/FmkdView',
        name: 'FmkdView',
        component: () => import('@/components/FmkdView.vue'),
    },
    {
        path: '/ScadFilterView',
        name: 'ScadFilterView',
        component: () => import('@/components/ScadFilterView.vue'),
    },
    {
        path: '/LjbsView',
        name: 'LjbsView',
        component: () => import('@/components/LjbsView.vue'),
    },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/!* webpackChunkName: "about" *!/ '../views/AboutView.vue')
  }*/
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
